<template>
	<v-dialog v-model="nameChangeDialog" width="600px">
    <customDialog>
      <template v-slot:title>
        {{t('changeName')}}
        <button id="dialog_exit" @click="nameChangeDialog = false">
          <img src="@/assets/images/popup_close.png" id="btn_img">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10"
            v-if="isMobile == false">
            <v-row class="ma-0 pa-0 pt-7 pb-10 dialog_text" align="center">
              <v-col class="ma-0 pa-0" cols="auto">
                {{t('changeName')}}
              </v-col>
              <v-col class="ma-0 pa-0 pl-3" cols="auto">
                <input class="change_name_input" v-model="newName">
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" width="8rem" height="2rem"
						 		@click="nameChangeDialog = false">{{t('back')}}</v-btn>
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" width="8rem" height="2rem"
							 	@click="updateName" :loading="updateLoading">{{t('change')}}</v-btn>
            </v-row>
          </v-col>

          <!-- ################### Mobile ################### -->
          <v-col class="ma-0 pa-0" cols="11" v-else>
            <v-col class="ma-0 pa-0 pt-7 pb-10 dialog_text" align="left">
              <v-col class="ma-0 pa-0 pb-1" cols="auto">
                {{t('changeName')}}
              </v-col>
              <v-col class="ma-0 pa-0" cols="auto">
                <input class="change_name_input" v-model="newName"
                  style="width:100%;">
              </v-col>
            </v-col>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" width="6rem" height="2rem"
						 		@click="nameChangeDialog = false">{{t('back')}}</v-btn>
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" width="6rem" height="2rem"
							 	@click="updateName" :loading="updateLoading">{{t('change')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';

export default {
	props: {
		dialogVisible: Boolean,
    currentId : String,
    currentName : String,
    editType : String,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		nameChangeDialog: false,
    streamData: {},
    newName: '',
    updateLoading: false,
    isMobile: false,
	}),
	watch: {
		dialogVisible: function(isVisible) {
			this.nameChangeDialog = isVisible;
      if(isVisible) this.newName = this.currentName;
		},
		nameChangeDialog: function(item) {
			this.$emit('visible', item);
      this.isMobile = this.$store.state.isMobile;
		},
	},
  mounted() {
    this.newName = this.currentName;
    this.streamData = this.$store.getters.getStreamInfo;
  },
  methods: {
    completeNameUpdate(res){
      this.showToastMessage(this.tmb('requestSuccess'));
      this.$emit('nameUpdate', { editType: this.editType, ...res.data });
      this.updateLoading = false;
      this.nameChangeDialog = false;
    },
		checkTitleDuplication(editType) {
			if(editType == 'cameraGroup') {
				const find = this.$store.state.allCameraGroupList.findIndex((el, index, arr) => el.groupName === this.newName);
				if(find == -1) {
					return false;
				} else return true;
			} else if(editType == 'splitlist') {
				const find = this.$store.state.allSplitScreenList.findIndex((el, index, arr) => el.splitName === this.newName);
				if(find == -1) {
					return false;
				} else return true;
			} else if(editType == 'privateSplitList') {
				const find = this.$store.state.allPrivateSplitScreenList.findIndex((el, index, arr) => el.splitName === this.newName);
				if(find == -1) {
					return false;
				} else return true;
			}
		},
		groupLabelNameCheckDuplicate() {
			let savedStoreGroupLabel = this.$store.getters.getStoreGroupLabel;
			if(savedStoreGroupLabel.length > 0) {
				let duplicateCheck = savedStoreGroupLabel.some((element) => {
					return element.labelName === this.newName
				});
				if(duplicateCheck == false) {
					return false;
				} else { // duplicateCheck가 true일때는 labelName 중복
					return true;
				}
			} else {
				return false;
			}
		},
    async updateName() {
      this.updateLoading = true;
      if(this.newName === '') this.newName = this.currentName;

      switch(this.editType){
        case "bookmark":
					if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}

          await this.networkController.updateBookmark({ name: this.newName }, this.streamData.contractCd, this.streamData.portNo, this.currentId)
          .then(async(res)=> {
            console.log('%cBookmark name update\n', "color:#008DD0;", res.data);
					  this.completeNameUpdate(res)
          })
          .catch((error) => this.updateLoading = false )
          break;

        case 'clip':
					if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}

          await this.networkController.updateVideoClip({ name: this.newName }, this.streamData.contractCd, this.streamData.portNo, this.currentId)
          .then(async (res) => {
            console.log('%cClip name update\n', "color:#008DD0;", res.data);
            this.completeNameUpdate(res)
          })
          .catch(error => this.updateLoading = false)
          break;

        case 'cameraGroup': 
          if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}
					if(this.checkTitleDuplication(this.editType)) {
						this.showToastMessage(this.tmb('nameAlreadyExists'));
						this.updateLoading = false;
						break;
					}

          await this.networkController.updateCameraCheckListGroup({groupName: this.newName}, this.currentId)
          .then(async (res)=> {
            console.log('%cCameraGroupList name update\n', "color:#008DD0;", res.data);
            this.completeNameUpdate(res)
          })
          .catch( error => this.updateLoading = false)
          
          break;

        case 'splitlist':
          if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}
					if(this.checkTitleDuplication(this.editType)) {
						this.showToastMessage(this.tmb('nameAlreadyExists'));
						this.updateLoading = false;
						break;
					}

          await this.networkController.updateCameraSplit({splitName: this.newName}, this.currentId)
          .then(async (res) => {
            console.log('%cSplitList name update\n', "color:#008DD0;", res.data);
            this.completeNameUpdate(res)
          })
          .catch(error => this.updateLoading = false)
          break;

				case 'privateSplitList':
					if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}
					if(this.checkTitleDuplication(this.editType)) {
						this.showToastMessage(this.tmb('nameAlreadyExists'));
						this.updateLoading = false;
						break;
					}
					await this.networkController.updatePrivateUserSplitScreen({splitName: this.newName}, this.currentId)
          .then(async (res) => {
            console.log('%cSplitList name update\n', "color:#008DD0;", res.data);
            this.completeNameUpdate(res)
          })
          .catch(error => this.updateLoading = false)
					break;

        case 'preset':
          if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}

          await this.networkController.updateCameraSettingPreset({settingName: this.newName}, this.streamData.contractCd, this.streamData.portNo, this.currentId)
          .then(async(res)=>{
            console.log('%cPreset name update\n', "color:#008DD0;", res.data);
					  this.completeNameUpdate(res)
          })
          .catch(error => this.updateLoading = false);
					break;
				
				case 'labelName':
					if(this.newName === '') this.newName = this.currentName;
					if(this.checkStringOnlyBlankPattern(this.newName) || this.checkStringBlankPattern(this.newName)) {
						this.showToastMessage('名前の形式が無効です。');
						this.updateLoading = false;
						return;
					}
					if(this.groupLabelNameCheckDuplicate()) {
						this.showToastMessage('既に存在するグループラベル名です。');
						this.updateLoading = false
						return;
					}

					this.networkController.updateStoreGroupLabel({labelName: this.newName}, this.currentId)
					.then(async (res) => {
            console.log('%cgroupLabel name update\n', "color:#008DD0;", res.data);
						this.completeNameUpdate(res);
					}).catch(error => {
						this.updateLoading = false
					});
					break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.change_name_input {
  width: 25em;
  padding-left: 1em;
  color: white;
  background-color: #272727;
  border: 1px solid #4A4A4A;
  border-radius: 3px;
  height: 2.5em;
}
</style>